import * as Connection from "./connection/"
import * as Outreach from "./outreach"
import * as Rapporten from "./rapporten"
import * as Cities from "./cities"
import * as Contactpoint from "./contactpoint"
import * as Automatictask from "./automatictask"
import * as Filestatus from "./filestatus"
import * as Companies from "./companies"
import * as User from "./user"
import * as ActivityTypes from "./activitytypes"
import * as Disabilities from "./disabilities"
import * as Languages from "./languages"
import * as Problems from "./problems"
import * as Client from "./client"
import * as ContactPersonTypes from "./contactpersontypes"

import * as Selectie from "./selectie"
import selectieSagas from "./selectie/sagas"

import * as Navigate from "./navigate"

import { Store, applyMiddleware, combineReducers, createStore } from "redux"
import { all, fork } from 'redux-saga/effects'

import { RouterState, connectRouter, routerMiddleware } from "connected-react-router"
import {createBrowserHistory, History} from "history";
import { composeWithDevTools } from "redux-devtools-extension"
import createSagaMiddleware from "redux-saga"


// Top level state
export interface IApplicationState {
    connection: Connection.IState;
    rapporten: Rapporten.IRapportenState;
    selectie: Selectie.IState;
    outreach: Outreach.IState;
    cities: Cities.IState;
    router: RouterState;
    navigate: Navigate.IState;
    contactpoint: Contactpoint.IState;
    automatictask: Automatictask.IState;
    filestatus: Filestatus.IState;
    companies: Companies.IState;
    user: User.IState;
    activitytypes: ActivityTypes.IState;
    disabilities: Disabilities.IState;
    languages: Languages.IState;
    problems: Problems.IState;
    client: Client.IState;
    contactpersontypes: ContactPersonTypes.IState;
}

// Root reducer, containing all reducers
export const rootReducer = (history: History) => combineReducers<IApplicationState>({
    router: connectRouter(history),
    connection: Connection.reducers,
    rapporten: Rapporten.rootReducer,
    selectie: Selectie.reducer,
    outreach: Outreach.Reducers,
    cities: Cities.Reducers,
    navigate: Navigate.Reducers,
    contactpoint: Contactpoint.Reducers,
    automatictask: Automatictask.Reducers,
    filestatus: Filestatus.Reducers,
    companies: Companies.Reducers,
    user: User.Reducers,
    activitytypes: ActivityTypes.Reducers,
    disabilities: Disabilities.Reducers,
    languages: Languages.Reducers,
    problems: Problems.Reducers,
    client: Client.Reducers,
    contactpersontypes: ContactPersonTypes.Reducers
});

// Root action creator holder
export const RootActionCreators = {
    Connection: Connection.ActionCreators,
    Rapporten: Rapporten.ActionCreators,
    Selectie: Selectie.SelectieActionCreator, 
    Outreach: Outreach.ActionCreators,
    Cities: Cities.ActionCreators,
    Navigate: Navigate.ActionCreators,
    Contactpoint: Contactpoint.ActionCreators,
    Automatictask: Automatictask.ActionCreators,
    Filestatus: Filestatus.ActionCreators,
    Companies: Companies.ActionCreators,
    User: User.ActionCreators,
    ActivityTypes: ActivityTypes.ActionCreators,
    Disabilities: Disabilities.ActionCreators,
    Languages: Languages.ActionCreators,
    Problems: Problems.ActionCreators,
    Client: Client.ActionCreators,
    ContactPersonTypes: ContactPersonTypes.ActionCreators,
}

// Root saga, containing all sagas
export function* rootSaga() {
    yield all([
        fork(Connection.sagas), 
        fork(Rapporten.midSaga), 
        fork(selectieSagas), 
        fork(Outreach.sagas), 
        fork(Cities.sagas), 
        fork(Navigate.Sagas), 
        fork(Contactpoint.sagas), 
        fork(Automatictask.sagas), 
        fork(Filestatus.sagas), 
        fork(Companies.sagas), 
        fork(User.sagas), 
        fork(ActivityTypes.sagas), 
        fork(Disabilities.sagas), 
        fork(Languages.sagas),
        fork(Problems.sagas),
        fork(Client.sagas),
        fork(ContactPersonTypes.sagas)]);
}

export const history = createBrowserHistory();

// Export commonly used types for convenience
export { UserAccessLevel } from './user/userInfo';
export { hasAccessLevel, hasAllAccessLevels, hasAnyAccessLevel } from './user/userInfo';

// Creating the main store
export default function configureStore() : Store<IApplicationState>
{
    const devTools = composeWithDevTools({});
    const sagaMiddleware = createSagaMiddleware()

    const store = createStore(
        rootReducer(history),
        devTools(applyMiddleware(sagaMiddleware, routerMiddleware(history)))
    );

    sagaMiddleware.run(rootSaga);

    return store;
}